import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import Select from 'react-select';
import axiosInstance from '../../api/axios';
import Header from '../../layouts/Header';
import { toast } from 'react-toastify';

/* ─── helpers ──────────────────────────────────────────────── */
const fmt = (iso) =>
    new Date(iso).toLocaleString('en-IN', {
        day: '2-digit', month: 'short', year: 'numeric',
        hour: '2-digit', minute: '2-digit',
    });

/* ─── Progress Bar for qty ─────────────────────────────────── */
const QtyBar = ({ transferred, requested }) => {
    const pct = requested > 0 ? Math.min((transferred / requested) * 100, 100) : 0;
    const color = pct === 0 ? '#e5e7eb' : pct < 50 ? '#f59e0b' : pct < 100 ? '#6366f1' : '#10b981';
    return (
        <div style={{ marginTop: 6 }}>
            <div style={{ height: 4, background: '#f0f0f0', borderRadius: 99, overflow: 'hidden' }}>
                <div style={{ height: '100%', width: `${pct}%`, background: color, borderRadius: 99, transition: 'width .3s ease' }} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 3 }}>
                <span style={{ fontSize: 10, color: '#9ca3af' }}>0</span>
                <span style={{ fontSize: 10, color: pct === 100 ? '#10b981' : '#9ca3af', fontWeight: pct === 100 ? 700 : 400 }}>
                    {pct === 100 ? '✓ Fully Fulfilled' : `${Math.round(pct)}%`}
                </span>
                <span style={{ fontSize: 10, color: '#9ca3af' }}>{requested}</span>
            </div>
        </div>
    );
};

/* ─── Current Stock Badge ───────────────────────────────────── */
const CurrentStockBadge = ({ currentStock, unit, stockInfo, isDark }) => {

    console.log("Current Stock :", currentStock);


    if (currentStock === undefined || currentStock === null) return null;

    const isLow = currentStock < 10;
    const isOut = currentStock <= 0;
    const color = isOut ? '#ef4444' : isLow ? '#f59e0b' : '#10b981';
    const bg = isOut
        ? (isDark ? '#450a0a' : '#fee2e2')
        : isLow
            ? (isDark ? '#451a03' : '#fef3c7')
            : (isDark ? '#052e16' : '#dcfce7');

    return (
        <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 5,
            background: bg, border: `1px solid ${color}33`,
            borderRadius: 7, padding: '3px 10px', marginTop: 8,
        }}>
            <span style={{ fontSize: 10, fontWeight: 700, color, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                {isOut ? '⚠ Out of Stock' : isLow ? '⚡ Low Stock' : '✓ In Stock'}
            </span>
            <span style={{ width: 1, height: 10, background: color + '44' }} />
            <span style={{ fontSize: 11, fontWeight: 800, color }}>
                {currentStock} <span style={{ fontWeight: 500, opacity: 0.8 }}>{unit}</span>
            </span>
        </div>
    );
};

/* ─── Item Row Card ─────────────────────────────────────────── */
// const ItemCard = ({ item, index, value, onChange, isDark, currentStockInfo }) => {
//     const rm = item.rawMaterial || {};
//     const requested = item.requestedQuantity || 0;
//     const transferred = Number(value) || 0;
//     const isOver = transferred > requested;
//     const isFull = transferred === requested && transferred > 0;

//     console.log("RM :", rm);


//     console.log("currentStockInfo", currentStockInfo);


//     // Find current stock for this raw material from selected storage location
//     const stockEntry = currentStockInfo?.find(s => s.rawMaterial?._id === rm._id);
//     console.log("Stock Entry:", stockEntry);

//     const currentStock = stockEntry?.currentStock;
//     const stockStatus = stockEntry?.stockInfo;

//     const cardBg = isDark ? '#1a2132' : '#fff';
//     const border = isDark ? '#2d3748' : '#e5e7eb';
//     const textMain = isDark ? '#f3f4f6' : '#111827';
//     const textMuted = isDark ? '#9ca3af' : '#6b7280';

//     return (
//         <div style={{
//             background: cardBg,
//             border: `1.5px solid ${isFull ? '#10b981' : isOver ? '#ef4444' : border}`,
//             borderRadius: 12,
//             padding: '18px 20px',
//             transition: 'border-color .2s, box-shadow .2s',
//             boxShadow: isFull
//                 ? '0 0 0 3px rgba(16,185,129,0.10)'
//                 : isOver
//                     ? '0 0 0 3px rgba(239,68,68,0.10)'
//                     : isDark ? '0 2px 8px rgba(0,0,0,0.25)' : '0 1px 3px rgba(0,0,0,0.06)',
//             animation: 'slideIn .3s ease both',
//             animationDelay: `${index * 0.05}s`,
//             zIndex: 0,
//         }}>
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16, flexWrap: 'wrap' }}>

//                 {/* Left: Material Info */}
//                 <div style={{ flex: 1, minWidth: 200 }}>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
//                         <div style={{
//                             width: 32, height: 32, borderRadius: 8, flexShrink: 0,
//                             background: isDark ? '#252d3d' : '#eef2ff',
//                             display: 'flex', alignItems: 'center', justifyContent: 'center',
//                             fontSize: 14, fontWeight: 800, color: '#6366f1',
//                         }}>
//                             {(rm.name || '?')[0].toUpperCase()}
//                         </div>
//                         <div>
//                             <div style={{ fontWeight: 700, fontSize: 14, color: textMain }}>{rm.name || '—'}</div>
//                             {rm.description && (
//                                 <div style={{ fontSize: 11, color: textMuted, marginTop: 1, maxWidth: 260, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
//                                     {rm.description}
//                                 </div>
//                             )}
//                         </div>
//                     </div>

//                     <div style={{ display: 'flex', gap: 8, marginTop: 10, flexWrap: 'wrap' }}>
//                         {rm.subCategory?.name && (
//                             <span style={{ fontSize: 11, background: isDark ? '#252d3d' : '#f3f4f6', color: textMuted, padding: '2px 8px', borderRadius: 6, fontWeight: 600 }}>
//                                 {rm.subCategory.name}
//                             </span>
//                         )}
//                         {rm.mainCategory?.name && (
//                             <span style={{ fontSize: 11, background: isDark ? '#252d3d' : '#f3f4f6', color: textMuted, padding: '2px 8px', borderRadius: 6, fontWeight: 600 }}>
//                                 {rm.mainCategory.name}
//                             </span>
//                         )}
//                         {rm.hsn && (
//                             <span style={{ fontSize: 11, color: '#6366f1', background: isDark ? '#1e1b4b' : '#eef2ff', padding: '2px 8px', borderRadius: 6, fontFamily: 'monospace', fontWeight: 600 }}>
//                                 HSN: {rm.hsn}
//                             </span>
//                         )}
//                     </div>

//                     {/* Current Stock Badge — shown when a storage location is selected */}
//                     <CurrentStockBadge
//                         currentStock={currentStock}
//                         unit={rm.unit}
//                         stockInfo={stockStatus}
//                         isDark={isDark}
//                     />

//                     {/* Progress bar */}
//                     {/* <div style={{ marginTop: 10, maxWidth: 280 }}>
//                         <QtyBar transferred={transferred} requested={requested} />
//                     </div> */}
//                 </div>

//                 {/* Right: Qty Controls */}
//                 <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 8, minWidth: 180 }}>

//                     {/* Requested Badge */}
//                     <div style={{ textAlign: 'right' }}>
//                         <div style={{ fontSize: 10, color: textMuted, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 2 }}>
//                             Requested
//                         </div>
//                         <div style={{ fontWeight: 800, fontSize: 20, color: '#6366f1' }}>
//                             {requested}
//                             <span style={{ fontSize: 12, fontWeight: 500, color: textMuted, marginLeft: 4 }}>{rm.unit || ''}</span>
//                         </div>
//                     </div>

//                     {/* Transfer Qty Input */}
//                     <div style={{ textAlign: 'right' }}>
//                         <div style={{ fontSize: 10, color: textMuted, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 4 }}>
//                             Transfer Qty
//                         </div>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
//                             {/* Stepper buttons */}
//                             {/* <button
//                                 onClick={() => onChange(Math.max(0, transferred - 1))}
//                                 style={{
//                                     width: 30, height: 36, borderRadius: 7, border: `1px solid ${border}`,
//                                     background: isDark ? '#252d3d' : '#f9fafb', color: textMain,
//                                     cursor: 'pointer', fontSize: 16, fontWeight: 700,
//                                     display: 'flex', alignItems: 'center', justifyContent: 'center',
//                                     transition: 'all .15s',
//                                 }}
//                                 onMouseEnter={e => e.currentTarget.style.background = isDark ? '#2d3748' : '#e5e7eb'}
//                                 onMouseLeave={e => e.currentTarget.style.background = isDark ? '#252d3d' : '#f9fafb'}
//                             >−</button> */}

//                             <input
//                                 type="number"
//                                 min={0}
//                                 max={requested}
//                                 value={value}
//                                 onChange={e => onChange(e.target.value)}
//                                 style={{
//                                     width: 72, height: 36, textAlign: 'center',
//                                     border: `1.5px solid ${isOver ? '#ef4444' : isFull ? '#10b981' : border}`,
//                                     borderRadius: 8, background: isDark ? '#1e293b' : '#fff',
//                                     color: isOver ? '#ef4444' : isFull ? '#10b981' : textMain,
//                                     fontSize: 15, fontWeight: 700, outline: 'none',
//                                     fontFamily: 'inherit',
//                                     transition: 'border-color .2s',
//                                 }}
//                             />

//                             {/* <button
//                                 onClick={() => onChange(Math.min(requested, transferred + 1))}
//                                 style={{
//                                     width: 30, height: 36, borderRadius: 7, border: `1px solid ${border}`,
//                                     background: isDark ? '#252d3d' : '#f9fafb', color: textMain,
//                                     cursor: 'pointer', fontSize: 16, fontWeight: 700,
//                                     display: 'flex', alignItems: 'center', justifyContent: 'center',
//                                     transition: 'all .15s',
//                                 }}
//                                 onMouseEnter={e => e.currentTarget.style.background = isDark ? '#2d3748' : '#e5e7eb'}
//                                 onMouseLeave={e => e.currentTarget.style.background = isDark ? '#252d3d' : '#f9fafb'}
//                             >+</button> */}

//                             {/* Fill Max btn */}
//                             <button
//                                 onClick={() => onChange(requested)}
//                                 title="Fill max (match requested)"
//                                 style={{
//                                     height: 36, padding: '0 10px', borderRadius: 7,
//                                     border: `1px solid ${isDark ? '#3730a3' : '#c7d2fe'}`,
//                                     background: isDark ? '#1e1b4b' : '#eef2ff',
//                                     color: '#6366f1', cursor: 'pointer', fontSize: 11,
//                                     fontWeight: 700, transition: 'all .15s', whiteSpace: 'nowrap',
//                                     fontFamily: 'inherit',
//                                 }}
//                                 onMouseEnter={e => e.currentTarget.style.background = isDark ? '#312e81' : '#e0e7ff'}
//                                 onMouseLeave={e => e.currentTarget.style.background = isDark ? '#1e1b4b' : '#eef2ff'}
//                             >
//                                 MAX
//                             </button>
//                         </div>

//                         {isOver && (
//                             <div style={{ fontSize: 11, color: '#ef4444', marginTop: 4, fontWeight: 600, textAlign: 'right' }}>
//                                 ⚠ Exceeds requested qty
//                             </div>
//                         )}
//                         {isFull && (
//                             <div style={{ fontSize: 11, color: '#10b981', marginTop: 4, fontWeight: 600, textAlign: 'right' }}>
//                                 ✓ Fully transferred
//                             </div>
//                         )}
//                     </div>

//                     {/* Unit label */}
//                     {rm.unit && (
//                         <div style={{ fontSize: 11, color: textMuted, fontWeight: 600 }}>Unit: {rm.unit}</div>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

const ItemCard = ({ item, index, value, onChange, isDark, currentStockInfo }) => {
    const rm = item.rawMaterial || {};
    const requested = item.requestedQuantity || 0;
    const transferred = Number(value) || 0;
    const isOver = transferred > requested;
    const isFull = transferred === requested && transferred > 0;

    // Find current stock for this raw material from selected storage location
    const stockEntry = currentStockInfo?.find(s => s.rawMaterial?._id === rm._id);
    const currentStock = stockEntry?.currentStock;
    const stockStatus = stockEntry?.stockInfo;

    // True only when a location is selected but this material isn't found in it
    const notAvailableInLocation = currentStockInfo !== null && currentStockInfo !== undefined && !stockEntry;

    const cardBg = isDark ? '#1a2132' : '#fff';
    const border = isDark ? '#2d3748' : '#e5e7eb';
    const textMain = isDark ? '#f3f4f6' : '#111827';
    const textMuted = isDark ? '#9ca3af' : '#6b7280';

    return (
        <div style={{
            background: cardBg,
            border: `1.5px solid ${isFull ? '#10b981' : isOver ? '#ef4444' : notAvailableInLocation ? '#f59e0b' : border}`,
            borderRadius: 12,
            padding: '18px 20px',
            transition: 'border-color .2s, box-shadow .2s',
            boxShadow: isFull
                ? '0 0 0 3px rgba(16,185,129,0.10)'
                : isOver
                    ? '0 0 0 3px rgba(239,68,68,0.10)'
                    : notAvailableInLocation
                        ? '0 0 0 3px rgba(245,158,11,0.08)'
                        : isDark ? '0 2px 8px rgba(0,0,0,0.25)' : '0 1px 3px rgba(0,0,0,0.06)',
            animation: 'slideIn .3s ease both',
            animationDelay: `${index * 0.05}s`,
            zIndex: 0,
        }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16, flexWrap: 'wrap' }}>

                {/* Left: Material Info */}
                <div style={{ flex: 1, minWidth: 200 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                        <div style={{
                            width: 32, height: 32, borderRadius: 8, flexShrink: 0,
                            background: isDark ? '#252d3d' : '#eef2ff',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: 14, fontWeight: 800, color: '#6366f1',
                        }}>
                            {(rm.name || '?')[0].toUpperCase()}
                        </div>
                        <div>
                            <div style={{ fontWeight: 700, fontSize: 14, color: textMain }}>{rm.name || '—'}</div>
                            {rm.description && (
                                <div style={{ fontSize: 11, color: textMuted, marginTop: 1, maxWidth: 260, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {rm.description}
                                </div>
                            )}
                        </div>
                    </div>

                    <div style={{ display: 'flex', gap: 8, marginTop: 10, flexWrap: 'wrap' }}>
                        {rm.subCategory?.name && (
                            <span style={{ fontSize: 11, background: isDark ? '#252d3d' : '#f3f4f6', color: textMuted, padding: '2px 8px', borderRadius: 6, fontWeight: 600 }}>
                                {rm.subCategory.name}
                            </span>
                        )}
                        {rm.mainCategory?.name && (
                            <span style={{ fontSize: 11, background: isDark ? '#252d3d' : '#f3f4f6', color: textMuted, padding: '2px 8px', borderRadius: 6, fontWeight: 600 }}>
                                {rm.mainCategory.name}
                            </span>
                        )}
                        {rm.hsn && (
                            <span style={{ fontSize: 11, color: '#6366f1', background: isDark ? '#1e1b4b' : '#eef2ff', padding: '2px 8px', borderRadius: 6, fontFamily: 'monospace', fontWeight: 600 }}>
                                HSN: {rm.hsn}
                            </span>
                        )}
                    </div>

                    {/* Stock status — shown when a storage location is selected */}
                    {notAvailableInLocation ? (
                        <div style={{
                            display: 'inline-flex', alignItems: 'center', gap: 5,
                            background: isDark ? '#451a03' : '#fffbeb',
                            border: `1px solid #f59e0b55`,
                            borderRadius: 7, padding: '3px 10px', marginTop: 8,
                        }}>
                            <span style={{ fontSize: 13 }}>🚫</span>
                            <span style={{ fontSize: 11, fontWeight: 700, color: '#d97706' }}>
                                Not available in this storage location
                            </span>
                        </div>
                    ) : (
                        <CurrentStockBadge
                            currentStock={currentStock}
                            unit={rm.unit}
                            stockInfo={stockStatus}
                            isDark={isDark}
                        />
                    )}
                </div>

                {/* Right: Qty Controls */}
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 8, minWidth: 180 }}>

                    {/* Requested Badge */}
                    <div style={{ textAlign: 'right' }}>
                        <div style={{ fontSize: 10, color: textMuted, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 2 }}>
                            Requested
                        </div>
                        <div style={{ fontWeight: 800, fontSize: 20, color: '#6366f1' }}>
                            {requested}
                            <span style={{ fontSize: 12, fontWeight: 500, color: textMuted, marginLeft: 4 }}>{rm.unit || ''}</span>
                        </div>
                    </div>

                    {/* Transfer Qty Input */}
                    {/* <div style={{ textAlign: 'right' }}>
                        <div style={{ fontSize: 10, color: textMuted, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 4 }}>
                            Transfer Qty
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <input
                                type="number"
                                min={0}
                                max={requested}
                                value={value}
                                onChange={e => onChange(e.target.value)}
                                style={{
                                    width: 72, height: 36, textAlign: 'center',
                                    border: `1.5px solid ${isOver ? '#ef4444' : isFull ? '#10b981' : border}`,
                                    borderRadius: 8, background: isDark ? '#1e293b' : '#fff',
                                    color: isOver ? '#ef4444' : isFull ? '#10b981' : textMain,
                                    fontSize: 15, fontWeight: 700, outline: 'none',
                                    fontFamily: 'inherit',
                                    transition: 'border-color .2s',
                                }}
                            />

                            
                            <button
                                onClick={() => onChange(requested)}
                                title="Fill max (match requested)"
                                style={{
                                    height: 36, padding: '0 10px', borderRadius: 7,
                                    border: `1px solid ${isDark ? '#3730a3' : '#c7d2fe'}`,
                                    background: isDark ? '#1e1b4b' : '#eef2ff',
                                    color: '#6366f1', cursor: 'pointer', fontSize: 11,
                                    fontWeight: 700, transition: 'all .15s', whiteSpace: 'nowrap',
                                    fontFamily: 'inherit',
                                }}
                                onMouseEnter={e => e.currentTarget.style.background = isDark ? '#312e81' : '#e0e7ff'}
                                onMouseLeave={e => e.currentTarget.style.background = isDark ? '#1e1b4b' : '#eef2ff'}
                            >
                                MAX
                            </button>
                        </div>

                        {isOver && (
                            <div style={{ fontSize: 11, color: '#ef4444', marginTop: 4, fontWeight: 600, textAlign: 'right' }}>
                                ⚠ Exceeds requested qty
                            </div>
                        )}
                        {isFull && (
                            <div style={{ fontSize: 11, color: '#10b981', marginTop: 4, fontWeight: 600, textAlign: 'right' }}>
                                ✓ Fully transferred
                            </div>
                        )}
                    </div> */}

                    {/* Unit label */}
                    {rm.unit && (
                        <div style={{ fontSize: 11, color: textMuted, fontWeight: 600 }}>Unit: {rm.unit}</div>
                    )}
                </div>
            </div>
        </div>
    );
};

/* ─── Main Component ────────────────────────────────────────── */
const StockTransfer = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const accessToken = localStorage.getItem('authToken');

    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    const isDark = skin === 'dark';

    // request passed via navigation state
    const request = location.state?.request;

    const [quantities, setQuantities] = useState({});
    const [saving, setSaving] = useState(false);

    const [storageLocations, setStorageLocations] = useState([]);
    const [selectedStorageLocation, setSelectedStorageLocation] = useState(null);

    const pageBg = isDark ? '#111827' : '#f3f4f6';
    const cardBg = isDark ? '#1a2132' : '#fff';
    const textMain = isDark ? '#f3f4f6' : '#111827';
    const textMuted = isDark ? '#9ca3af' : '#6b7280';
    const border = isDark ? '#2d3748' : '#e5e7eb';

    /* react-select custom styles */
    const selectStyles = {
        control: (base, state) => ({
            ...base,
            background: isDark ? '#1e293b' : '#fff',
            borderColor: state.isFocused ? '#6366f1' : (isDark ? '#2d3748' : '#e5e7eb'),
            borderWidth: 1.5,
            borderRadius: 9,
            zIndex: 9999,
            minHeight: 42,
            boxShadow: state.isFocused ? '0 0 0 3px rgba(99,102,241,0.15)' : 'none',
            '&:hover': { borderColor: '#6366f1' },
            fontFamily: "'Nunito', 'Segoe UI', sans-serif",
            fontSize: 13,
            fontWeight: 600,
        }),
        menu: (base) => ({
            ...base,
            background: isDark ? '#1a2132' : '#fff',
            border: `1.5px solid ${isDark ? '#2d3748' : '#e5e7eb'}`,
            borderRadius: 10,
            boxShadow: isDark ? '0 8px 24px rgba(0,0,0,0.4)' : '0 8px 24px rgba(0,0,0,0.1)',
            zIndex: 9999,
            fontFamily: "'Nunito', 'Segoe UI', sans-serif",
        }),
        option: (base, state) => ({
            ...base,
            background: state.isSelected
                ? '#6366f1'
                : state.isFocused
                    ? (isDark ? '#252d3d' : '#eef2ff')
                    : 'transparent',
            color: state.isSelected ? '#fff' : (isDark ? '#f3f4f6' : '#111827'),
            fontSize: 13,
            zIndex: 9999,
            fontWeight: state.isSelected ? 700 : 500,
            padding: '10px 14px',
            cursor: 'pointer',
        }),
        singleValue: (base) => ({
            ...base,
            color: isDark ? '#f3f4f6' : '#111827',
            fontWeight: 600,
            fontSize: 13,
        }),
        placeholder: (base) => ({
            ...base,
            color: isDark ? '#6b7280' : '#9ca3af',
            fontSize: 13,
        }),
        indicatorSeparator: () => ({ display: 'none' }),
        dropdownIndicator: (base) => ({
            ...base,
            color: isDark ? '#6b7280' : '#9ca3af',
            '&:hover': { color: '#6366f1' },
            zIndex: 9999,
        }),
        noOptionsMessage: (base) => ({
            ...base,
            color: isDark ? '#6b7280' : '#9ca3af',
            fontSize: 12,
        }),
    };

    /* Initialise quantities from items */
    useEffect(() => {
        if (request?.items) {
            const initial = {};
            request.items.forEach(item => {
                initial[item.rawMaterial?._id || item._id] = item.transferredQuantity ?? 0;
            });
            setQuantities(initial);
        }
    }, [request]);

    useEffect(() => {
        getNewStorageLocationData();
    }, []);

    const handleChange = (rawMaterialId, val) => {
        setQuantities(prev => ({ ...prev, [rawMaterialId]: val === '' ? '' : Number(val) }));
    };

    const hasOverflow = (request?.items || []).some(item => {
        const id = item.rawMaterial?._id || item._id;
        return (Number(quantities[id]) || 0) > item.requestedQuantity;
    });

    const totalItems = (request?.items || []).length;
    const filledItems = (request?.items || []).filter(item => {
        const id = item.rawMaterial?._id || item._id;
        return (Number(quantities[id]) || 0) > 0;
    }).length;

    const allFull = (request?.items || []).every(item => {
        const id = item.rawMaterial?._id || item._id;
        return Number(quantities[id]) === item.requestedQuantity;
    });

    const getNewStorageLocationData = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get("storage-location/getCurrentStock", { headers });
            if (response?.data?.data?.storageLocations) {
                console.log("Log OF Storages Location and Its Current Stocks :", response?.data?.data?.storageLocations);
                setStorageLocations(response?.data?.data?.storageLocations);
            }
        } catch (error) {
            toast.error("Failed to fetch storage location data.", {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
        }
    };

    /* Build react-select options from storageLocations */
    const storageLocationOptions = storageLocations.map(loc => ({
        value: loc._id,
        label: loc.name,
        sublabel: loc.city,
        stockInfo: loc.stockInfo,
        data: loc,
    }));

    /* Custom option label for react-select */
    const formatOptionLabel = ({ label, sublabel }) => (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <span style={{ fontWeight: 700, fontSize: 13 }}>{label}</span>
            {sublabel && <span style={{ fontSize: 11, color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>📍 {sublabel}</span>}
        </div>
    );

    /* stockInfo array for selected location */
    const selectedStockInfo = selectedStorageLocation?.stockInfo || null;

    const handleSubmit = async () => {
        if (!selectedStorageLocation) {
            toast.error('Please select a storage location before saving.', {
                position: 'top-right', autoClose: 3000, theme: isDark ? 'dark' : 'light',
            });
            return;
        }
        if (hasOverflow) {
            toast.error('Some quantities exceed the requested amount. Please fix before submitting.', {
                position: 'top-right', autoClose: 3000, theme: isDark ? 'dark' : 'light',
            });
            return;
        }
        setSaving(true);
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const items = (request.items || []).map(item => ({
                rawMaterial: item.rawMaterial?._id || item.rawMaterial,
                transferredQuantity: Number(quantities[item.rawMaterial?._id || item._id]) || 0,
            }));
            const body = {
                _id: request._id,
                outlet: request?.outlet?._id || request?.outlet || '',
                storageLocation: selectedStorageLocation.value,
                status: 'COMPLETED',
                // items,
            };
            // await axiosInstance.put('stock-requisition/update-transferred-quantity', body, { headers });
            await axiosInstance.put('stock-requisition/update-status-completed', body, { headers });
            toast.success('Transferred quantities saved successfully!', {
                position: 'top-right', autoClose: 3000, theme: isDark ? 'dark' : 'light',
            });
            navigate('/purchase/stocks-request');
        } catch (err) {
            console.log("Error in Updating :", err);
            
            // const msg = err?.response?.data?.message || 'Failed to save. Please try again.';
            // toast.error(msg, { position: 'top-right', autoClose: 3000, theme: isDark ? 'dark' : 'light' });
            if (err.response.status === 404) {
                toast.error(err.response.data.error, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
            if (err.response.status === 412) {
                toast.error(err.response.data.error, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
            if (err.response && err.response?.data?.status === false) {
                let errorMessage = err.response?.data?.data?.message;

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        } finally {
            setSaving(false);
        }
    };

    /* Fill all to max */
    const handleFillAll = () => {
        const all = {};
        (request?.items || []).forEach(item => {
            all[item.rawMaterial?._id || item._id] = item.requestedQuantity;
        });
        setQuantities(all);
    };

    /* Clear all */
    const handleClearAll = () => {
        const all = {};
        (request?.items || []).forEach(item => {
            all[item.rawMaterial?._id || item._id] = 0;
        });
        setQuantities(all);
    };

    if (!request) {
        return (
            <React.Fragment>
                <Header onSkin={setSkin} />
                <div className="main main-app p-3 p-lg-4" style={{ minHeight: '100vh', background: pageBg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ textAlign: 'center', padding: 40 }}>
                        <div style={{ fontSize: 48, marginBottom: 12 }}>📦</div>
                        <div style={{ fontWeight: 700, fontSize: 16, color: textMain, marginBottom: 8 }}>No request data found</div>
                        <div style={{ color: textMuted, fontSize: 13, marginBottom: 20 }}>Please navigate from the Stock Requests page</div>
                        <button onClick={() => navigate('/purchase/stocks-request')} style={{
                            background: '#6366f1', color: '#fff', border: 'none', borderRadius: 8,
                            padding: '9px 22px', fontWeight: 700, fontSize: 13, cursor: 'pointer',
                        }}>← Back to Stock Requests</button>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <link href="https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700;800&display=swap" rel="stylesheet" />
            <style>{`
                @keyframes slideIn {
                    from { opacity: 0; transform: translateY(14px); }
                    to   { opacity: 1; transform: translateY(0); }
                }
                input[type=number]::-webkit-inner-spin-button,
                input[type=number]::-webkit-outer-spin-button { -webkit-appearance: none; }
                input[type=number] { -moz-appearance: textfield; }
            `}</style>

            <Header onSkin={setSkin} />

            <div className="main main-app p-3 p-lg-4" style={{
                minHeight: '100vh', background: pageBg,
                fontFamily: "'Nunito', 'Segoe UI', sans-serif",
                paddingBottom: 100,
            }}>
                <div>

                    {/* ── Page Header ── */}
                    <div style={{ marginBottom: 20, animation: 'slideIn .3s ease both' }}>
                        <button onClick={() => navigate('/purchase/stocks-request')} style={{
                            background: 'none', border: 'none', cursor: 'pointer',
                            display: 'inline-flex', alignItems: 'center', gap: 5,
                            color: '#6366f1', fontSize: 13, fontWeight: 700, padding: 0, marginBottom: 10,
                            fontFamily: 'inherit',
                        }}>
                            ← Back to Stock Requests
                        </button>
                        <h4 style={{ fontWeight: 800, fontSize: 22, margin: 0, color: textMain }}>
                            Transfer Stock
                        </h4>
                        <p style={{ color: textMuted, margin: '3px 0 0', fontSize: 13 }}>
                            Update transferred quantities for each raw material
                        </p>
                    </div>

                    {/* ── Request Info Card ── */}
                    <div style={{
                        background: cardBg, border: `1px solid ${border}`,
                        borderRadius: 12, padding: '16px 20px', marginBottom: 16,
                        animation: 'slideIn .3s ease both', animationDelay: '0.05s',
                    }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
                            <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
                                <div>
                                    <div style={{ fontSize: 10, color: textMuted, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 3 }}>Indent No.</div>
                                    <div style={{ fontFamily: 'monospace', fontWeight: 800, fontSize: 16, color: '#6366f1' }}>{request.indentNumber}</div>
                                </div>
                                <div>
                                    <div style={{ fontSize: 10, color: textMuted, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 3 }}>Outlet</div>
                                    <div style={{ fontWeight: 700, fontSize: 13, color: textMain }}>{request?.outlet?.name || '—'}</div>
                                    {request?.outlet?.city && <div style={{ fontSize: 11, color: textMuted }}>{request.outlet.city}</div>}
                                </div>
                                <div>
                                    <div style={{ fontSize: 10, color: textMuted, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 3 }}>FY</div>
                                    <div style={{ fontWeight: 700, fontSize: 13, color: textMain }}>{request.fin_year}</div>
                                </div>
                                <div>
                                    <div style={{ fontSize: 10, color: textMuted, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 3 }}>Created</div>
                                    <div style={{ fontWeight: 600, fontSize: 12, color: textMain }}>{fmt(request.createdAt)}</div>
                                </div>
                            </div>

                            {/* Progress summary */}
                            {/* <div style={{
                                display: 'flex', alignItems: 'center', gap: 10,
                                background: isDark ? '#252d3d' : '#f9fafb',
                                border: `1px solid ${border}`, borderRadius: 8, padding: '8px 14px',
                            }}>
                                <div style={{ textAlign: 'center' }}>
                                    <div style={{ fontWeight: 800, fontSize: 18, color: '#6366f1' }}>{filledItems}</div>
                                    <div style={{ fontSize: 10, color: textMuted, fontWeight: 600 }}>of {totalItems} filled</div>
                                </div>
                                <div style={{ width: 1, height: 36, background: border }} />
                                <div style={{ textAlign: 'center' }}>
                                    <div style={{ fontWeight: 800, fontSize: 18, color: allFull ? '#10b981' : '#f59e0b' }}>
                                        {totalItems > 0 ? Math.round((filledItems / totalItems) * 100) : 0}%
                                    </div>
                                    <div style={{ fontSize: 10, color: textMuted, fontWeight: 600 }}>complete</div>
                                </div>
                            </div> */}
                        </div>
                    </div>

                    {/* ── Storage Location Selector ── */}
                    <div className='d-flex gap-5' style={{
                        background: cardBg, border: `1px solid ${border}`,
                        borderRadius: 12, padding: '16px 20px', marginBottom: 16,
                        animation: 'slideIn .3s ease both', animationDelay: '0.08s',
                    }}>
                        <div className='w-25' style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                            <span style={{
                                width: 28, height: 28, borderRadius: 7,
                                background: isDark ? '#252d3d' : '#eef2ff',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: 14,
                            }}>🏪</span>
                            <div>
                                <div style={{ fontWeight: 700, fontSize: 13, color: textMain }}>Storage Location</div>
                                <div style={{ fontSize: 11, color: textMuted }}>Select the source store for this transfer</div>
                            </div>
                            <span style={{
                                marginLeft: 4, fontSize: 10, color: '#ef4444', fontWeight: 700,
                                background: '#fee2e2', padding: '2px 6px', borderRadius: 5,
                            }}>REQUIRED</span>
                        </div>

                        <div className='w-75'>
                            <Select
                                options={storageLocationOptions}
                                value={selectedStorageLocation}
                                onChange={setSelectedStorageLocation}
                                formatOptionLabel={formatOptionLabel}
                                placeholder="Select storage location…"
                                styles={selectStyles}
                                isClearable
                                isSearchable
                                noOptionsMessage={() => 'No storage locations found'}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                            />
                            {selectedStorageLocation && (
                                <div style={{
                                    marginTop: 10, display: 'flex', alignItems: 'center', gap: 6,
                                    fontSize: 12, color: '#10b981', fontWeight: 600,
                                }}>
                                    <span>✓</span>
                                    <span>
                                        Showing live stock from <strong>{selectedStorageLocation.label}</strong>
                                        {selectedStorageLocation.sublabel && ` — ${selectedStorageLocation.sublabel}`}
                                    </span>
                                </div>
                            )}
                            {!selectedStorageLocation && (
                                <div style={{
                                    marginTop: 10, display: 'flex', alignItems: 'center', gap: 6,
                                    fontSize: 12, color: '#f59e0b', fontWeight: 600,
                                }}>
                                    <span>ℹ</span>
                                    <span>Select a storage location to view current stock levels on each item</span>
                                </div>
                            )}
                        </div>

                    </div>

                    {/* ── Bulk Actions ── */}
                    {/* <div style={{
                        display: 'flex', justifyContent: 'flex-end', gap: 8, marginBottom: 12,
                        animation: 'slideIn .3s ease both', animationDelay: '0.1s',
                    }}>
                        <button onClick={handleClearAll} style={{
                            background: isDark ? '#1e293b' : '#fff', border: `1px solid ${border}`,
                            borderRadius: 7, padding: '7px 14px', fontSize: 12, fontWeight: 700,
                            color: textMuted, cursor: 'pointer', fontFamily: 'inherit',
                            transition: 'all .15s',
                        }}
                            onMouseEnter={e => e.currentTarget.style.borderColor = '#ef4444'}
                            onMouseLeave={e => e.currentTarget.style.borderColor = border}
                        >
                            ✕ Clear All
                        </button>
                        <button onClick={handleFillAll} style={{
                            background: isDark ? '#1e1b4b' : '#eef2ff', border: `1px solid ${isDark ? '#3730a3' : '#c7d2fe'}`,
                            borderRadius: 7, padding: '7px 14px', fontSize: 12, fontWeight: 700,
                            color: '#6366f1', cursor: 'pointer', fontFamily: 'inherit',
                            transition: 'all .15s',
                        }}
                            onMouseEnter={e => e.currentTarget.style.background = isDark ? '#312e81' : '#e0e7ff'}
                            onMouseLeave={e => e.currentTarget.style.background = isDark ? '#1e1b4b' : '#eef2ff'}
                        >
                            ⚡ Fill All MAX
                        </button>
                    </div> */}

                    {/* ── Item Cards ── */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: '100px' }}>
                        {(request.items || []).map((item, idx) => {
                            const id = item.rawMaterial?._id || item._id;
                            return (
                                <ItemCard
                                    key={id || idx}
                                    item={item}
                                    index={idx}
                                    value={quantities[id] ?? 0}
                                    onChange={(val) => handleChange(id, val)}
                                    isDark={isDark}
                                    currentStockInfo={selectedStockInfo}
                                />
                            );
                        })}
                    </div>

                    {/* ── Overflow warning ── */}
                    {hasOverflow && (
                        <div style={{
                            marginTop: 14, padding: '12px 16px',
                            background: '#fee2e2', border: '1px solid #fca5a5',
                            borderRadius: 10, color: '#dc2626', fontSize: 13, fontWeight: 600,
                            display: 'flex', alignItems: 'center', gap: 8,
                            animation: 'slideIn .2s ease both',
                        }}>
                            <span style={{ fontSize: 18 }}>⚠️</span>
                            One or more quantities exceed the requested amount. Please correct them before saving.
                        </div>
                    )}

                </div>

                {/* ── Sticky Footer Submit Bar ── */}
                <div style={{
                    position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 100,
                    background: isDark ? 'rgba(17,24,39,0.97)' : 'rgba(255,255,255,0.97)',
                    backdropFilter: 'blur(12px)',
                    borderTop: `1px solid ${border}`,
                    padding: '14px 20px',
                    display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12,
                    boxShadow: isDark ? '0 -4px 20px rgba(0,0,0,0.4)' : '0 -4px 20px rgba(0,0,0,0.08)',
                }}>
                    <div style={{ color: textMuted, fontSize: 13, marginRight: 8 }}>
                        <span style={{ fontWeight: 700, color: allFull ? '#10b981' : '#6366f1' }}>{filledItems}</span> of {totalItems} items filled
                        {allFull && <span style={{ marginLeft: 6, color: '#10b981', fontWeight: 700 }}>✓ All done!</span>}
                    </div>

                    <button onClick={() => navigate('/purchase/stocks-request')} style={{
                        background: 'transparent', border: `1px solid ${border}`,
                        borderRadius: 9, padding: '10px 22px',
                        fontSize: 13, fontWeight: 700, color: textMuted,
                        cursor: 'pointer', fontFamily: 'inherit', transition: 'all .15s',
                    }}>
                        Cancel
                    </button>

                    <button
                        onClick={handleSubmit}
                        disabled={saving || hasOverflow || !selectedStorageLocation}
                        style={{
                            background: (saving || hasOverflow || !selectedStorageLocation) ? '#a5b4fc' : '#6366f1',
                            border: 'none', borderRadius: 9, padding: '10px 30px',
                            fontSize: 13, fontWeight: 800, color: '#fff',
                            cursor: (saving || hasOverflow || !selectedStorageLocation) ? 'not-allowed' : 'pointer',
                            display: 'flex', alignItems: 'center', gap: 8,
                            fontFamily: 'inherit', transition: 'background .2s',
                            boxShadow: (saving || hasOverflow || !selectedStorageLocation) ? 'none' : '0 4px 14px rgba(99,102,241,0.35)',
                        }}
                        onMouseEnter={e => { if (!saving && !hasOverflow && selectedStorageLocation) e.currentTarget.style.background = '#4f46e5'; }}
                        onMouseLeave={e => { if (!saving && !hasOverflow && selectedStorageLocation) e.currentTarget.style.background = '#6366f1'; }}
                    >
                        {saving
                            ? <><Spinner animation="border" size="sm" /> Saving…</>
                            : <><span style={{ fontSize: 16 }}>📦</span> Complete Transfer</>}
                    </button>
                </div>
            </div>
        </React.Fragment>
    );
};

export default StockTransfer;